<mapfre-modal [modalOptions]="whereToFindModalOptions" [hideModal]="hideModal" (hideModalOutput)="resetHideModal()">
    <div class="modal-body locatepolicynum no-padding-top">
        <hr class="margin-bottom mb24" />
        <div class="margin-bottom mb8">
            {{ "SEARCH_YOUR_POLICY_DOCUMENTS_INVOICES" | translate }}
        </div>
        <ng-container *ngIf="isAcmic; else MAstate">
            <div class="margin-bottom mb-1">
                <img src="./assets/img/images/Document_ref.svg" alt="document icon"/>
            </div>
        </ng-container>
        <ng-template #MAstate>
            <div class="margin-bottom mb-1">
                <img src="./assets/img/images/Document_ref.png" alt="document icon" />
            </div>
        </ng-template>
        <mapfre-button additionalClasses="basic primary large-btn no-margin" [ngClass]="{ 'uppercase': isAcmic }" (click)="hideModalAction()">
            Close
        </mapfre-button>
    </div>
</mapfre-modal>